import React from 'react'
import img_3 from '../../../img/img_3.jpg'
import img_5 from '../../../img/img_5.png'
import { useTranslation } from 'react-i18next'
import FAQS from './FAQS'
import { Link } from 'react-router-dom'

const BRAND = '#6eb446'
const BRAND_SHADOW = '0 6px 20px rgba(110,180,70,0.35)'

interface FeatureSectionProps {
	title: string
	titleAccent: string
	body: string
	linkTo: string
	linkLabel: string
	image: string
	imageAlt: string
	reverse?: boolean
	bgColor?: string
}

const FeatureSection: React.FC<FeatureSectionProps> = ({
	title,
	titleAccent,
	body,
	linkTo,
	linkLabel,
	image,
	imageAlt,
	reverse = false,
	bgColor = '#ffffff',
}) => (
	<section style={{ backgroundColor: bgColor, borderBottom: '4px solid #000', padding: '5rem 1.5rem' }}>
		<div style={{ maxWidth: '1100px', margin: '0 auto' }}>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					gap: '3rem',
				}}
				className={reverse ? 'feature-row-reverse' : 'feature-row'}
			>
				<div style={{ flex: 1, width: '100%' }}>
					<h2
						style={{
							fontSize: 'clamp(1.75rem, 4vw, 2.5rem)',
							fontWeight: 800,
							color: '#1e293b',
							lineHeight: 1.2,
							marginBottom: '1.25rem',
						}}
					>
						{title} <span style={{ color: BRAND }}>{titleAccent}</span>
					</h2>
					<p
						style={{
							fontSize: '1.1rem',
							color: '#475569',
							lineHeight: 1.8,
							marginBottom: '2rem',
						}}
					>
						{body}
					</p>
					<Link
						to={linkTo}
						target="_blank"
						rel="noopener noreferrer"
						style={{
							display: 'inline-flex',
							alignItems: 'center',
							padding: '0.75rem 2rem',
							borderRadius: '9999px',
							backgroundColor: BRAND,
							color: '#fff',
							fontWeight: 700,
							fontSize: '1rem',
							textDecoration: 'none',
							boxShadow: BRAND_SHADOW,
							transition: 'transform 0.2s, filter 0.2s',
						}}
						onMouseEnter={(e) => {
							e.currentTarget.style.filter = 'brightness(1.1)'
							e.currentTarget.style.transform = 'translateY(-2px)'
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.filter = 'brightness(1)'
							e.currentTarget.style.transform = 'translateY(0)'
						}}
					>
						{linkLabel}
					</Link>
				</div>

				<div style={{ flex: 1, width: '100%' }}>
					<img
						src={image}
						alt={imageAlt}
						style={{
							width: '100%',
							borderRadius: '1rem',
							boxShadow: '0 20px 60px rgba(0,0,0,0.12)',
						}}
					/>
				</div>
			</div>
		</div>
	</section>
)

const Sections: React.FC = () => {
	const { t } = useTranslation()

	return (
		<>
			<style>{`
				@media (min-width: 768px) {
					.feature-row { flex-direction: row !important; }
					.feature-row-reverse { flex-direction: row-reverse !important; }
				}
			`}</style>

			<FeatureSection
				title={t('home.title2')}
				titleAccent={t('home.title2_2')}
				body={t('home.text2')}
				linkTo="https://labeldictate.com/text2barcode/"
				linkLabel={t('utilities.download')}
				image={img_5}
				imageAlt={t('home.title2')}
			/>

			<FeatureSection
				title={t('home.title3')}
				titleAccent={t('home.title3_3')}
				body={t('home.text3')}
				linkTo="https://labeldictate.com/suitemobilepos/"
				linkLabel={t('utilities.download')}
				image={img_3}
				imageAlt={t('home.title3')}
				reverse
				bgColor="#f8faf6"
			/>

			<FAQS />
		</>
	)
}

export default Sections
